import axios from "../http";

export function useShipment() {
  const getShipments = async () => axios.get('/api/shipments');
  const getCarriers = async () => axios.get('/api/shipments/carriers');
  const createShipments = async (params) => axios.post('/api/shipments', params);

  return {getShipments, getCarriers, createShipments}
}
